import React from "react";

interface NotifierProps {
  message: string;
}

const Notifier: React.FC<NotifierProps> = ({ message }) => {
  return (
    <div
      className={`fixed lg:hidden z-[2000] top-5 right-0 bg-[#2F1160] text-[#F609FF] font-[600] p-4 rounded-tl-lg rounded-bl-lg shadow-lg transition-transform transform ${
        message ? "translate-x-0" : "translate-x-full"
      }`}
    >
      {message}
    </div>
  );
};

export default Notifier;
